import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSliderChange, MatSliderModule } from '@angular/material/slider';
import { DialogDuplicateData } from './models/dialog-duplicate-data';

@Component({
    selector: 'app-duplicate-folder',
    templateUrl: './duplicate-folder.component.html',
    styleUrls: ['./duplicate-folder.component.scss'],
    imports: [MatCardModule, MatFormFieldModule, MatSliderModule, MatButtonModule, MatDialogClose]
})
export class DuplicateFolderComponent {
    /**
     * Constructeur.
     * @param dialogRef
     * @param data
     */
    constructor(
        public dialogRef: MatDialogRef<DuplicateFolderComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogDuplicateData
    ) {}

    /**
     * Appelée lorsque l'utilisateur clique sur le bouton 'Annuler'.
     */
    public cancel(): void {
        this.dialogRef.close();
    }

    public onSliderValueChange(event: MatSliderChange) {
        this.data.duplicateCount = event.value;
    }
}
